import { SLICE_TAG } from '@/constants';
import { apiSlice } from '@/features/slice/api-slice';

import { BalanceSheetResponseSchema } from './balance-sheet.schema';

export const balanceSheetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBalanceSheet: builder.query({
      query: (searchParams) => {
        return {
          url: `accounting/balance-sheet`,
          method: 'GET',
          params: searchParams,
        };
      },
      transformResponse: (response) => {
        return BalanceSheetResponseSchema.parse(response);
      },
      keepUnusedDataFor: 600,
      providesTags: [SLICE_TAG.BALANCE_SHEET],
    }),
  }),
});

export const { useGetBalanceSheetQuery, useLazyGetBalanceSheetQuery } =
  balanceSheetApi;
